<template>
	<ValidationProvider :name="$attrs.name" :rules="rules" v-slot="{ errors }">
		<v-switch
			v-model="inputValue"
			:label="question.options.label[lang]"
			:hint="question.options.hint ? question.options.hint[lang] : ''"
			:color="color.hexa"
			:error-messages="errors"
			:persistent-hint="question.options.persistentHint"
			:hide-details="!question.options.persistentHint"
			class="mb-6 mb-sm-8"
			@change="setValue()"
		></v-switch>
	</ValidationProvider>

</template>

<script>
import {ValidationProvider} from "vee-validate";
import AppStore from "../../../stores/AppStore";
import _ from "lodash";
import {EventBus} from "../../../services/Request";

export default {
	name: 'switch-viewer',

	components: {
		ValidationProvider
	},

	props: {
		value: {
			type: [Object],
			default() {
				return {}
			}
		},
		lang: {
			type: [String],
			default: 'fr'
		},
		color: {
			type: [String, Object],
			default: 'primary'
		},
		rules: {
			type: [Object, String],
			default: ""
		},
		questionIndex: {
			type: [Number],
			default: 0
		},
	},

	data: () => ({
		inputValue: false
	}),

	mounted() {

	},

	created() {
		if (!_.isEmpty(AppStore.rating.questions_answers) && AppStore.rating.questions_answers[this.question.id]) {
			const content = AppStore.rating.questions_answers[this.question.id].content;
			this.inputValue = (content === true || content === 'true' || content === 1 || content === '1');
		}
	},

	computed: {
		question: {
			get() {
				return this.value;
			},

			set(newValue) {
				this.$emit('input', newValue)
			}
		},
	},

	watch: {},

	methods: {
		setValue() {
			// console.info('setValue from swicth')
			this.$set(AppStore.rating.questions_answers, this.question.id, {
				question_id: this.question.id,
				content: this.inputValue
			})
			const conditionedQuestion = _.find(AppStore.conditionedQuestion, (q) => {
				return (q.conditional_question_id && (q.conditional_question_id.id || q.conditional_question_id) === this.question.id);
			});

			// console.log(conditionedQuestion)
			if (!_.isEmpty(conditionedQuestion)) {
				// console.log("CONDITIONED QUESTION")
				const condAnswer = conditionedQuestion.conditional_answer;
				let isMatch = false;
				if (this.inputValue === true || this.inputValue === 'true' || this.inputValue === 1 || this.inputValue === '1') {
					isMatch = (condAnswer === 'true' || condAnswer === true || condAnswer === '1' || condAnswer === 1);
				} else {
					isMatch = (condAnswer === 'false' || condAnswer === false || condAnswer === '0' || condAnswer === 0);
				}

				if (isMatch) {
					// console.log('set')
					// console.log('qi'+conditionedQuestion.id + 'remove d-none')
					EventBus.$emit('update-question', {
						id: conditionedQuestion.id,
						show: true
					})
				} else {
					// console.log('qi'+conditionedQuestion.id + ' d-none')
					EventBus.$emit('update-question', {
						id: conditionedQuestion.id,
						show: false
					})
				}
			}

			// console.log(AppStore.rating)
		}
	}
};
</script>
